import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import {
    Component,
    Input,
    Inject,
    OnInit,
    OnChanges,
} from "@angular/core";
import { EscalateTourByIdAction } from "@ngxs-store/control-tower-store/control-tower.actions";
import { AuthState } from "@ngxs-store/auth-store/auth.state";
import { LookupModel } from "@core/services/api.service";
import { LoadTicketTypesAction } from "@ngxs-store/lookup-store/lookup.actions";
import { Observable } from "rxjs";
import { LookupState } from "@ngxs-store/lookup-store/lookup.state";

@Component({
    selector: "app-tour-escalation-dialog",
    templateUrl: "./tour-escalation-dialog.component.html",
})
export class TourEscalationDialogComponent implements OnInit, OnChanges {
    @Select(LookupState.getTicketTypes) ticketTypes$: Observable<LookupModel[]>;
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() id: number;
    @Input() ticketTypes: LookupModel[];

    message: string = "";
    topic: string = "";
    amcoId: number;
    status: string = "Open";
    hasControlTowerRole: boolean = false;
    typesList: LookupModel[];
    typeId: number = 31;

    constructor(
        public dialogRef: MatDialogRef<TourEscalationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private store: Store
    ) {
        this.id = data.id;
        this.amcoId = data.amcoId;

        const token = this.store.selectSnapshot(AuthState.getDecodedToken);

        if (
            token.roles.findIndex(
                (hasRoleFn) =>
                    hasRoleFn === "ControlTowerUser"
            ) > -1
        ) {
            this.hasControlTowerRole = true;
        } else {
            this.hasControlTowerRole = false;
        }
    }

    ngOnInit(): void {
        this.store.dispatch(new LoadTicketTypesAction());
        this.ticketTypes$.subscribe(types => {
          this.typesList = types;
          if (this.typesList && this.typesList.length > 0 && !this.typesList) {
            this.typeId = this.typeId[0].id;
          }
        });
    }

    ngOnChanges() {
        if (!this.typeId) {
            const defaultOption = this.typesList.find(option => option.name.toLowerCase() === 'Low');
            if (defaultOption) {
              this.typeId = defaultOption.id;
            }
        }
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    addClick() {
        this.store.dispatch(new EscalateTourByIdAction(this.id, this.topic, this.message, this.hasControlTowerRole, this.typeId));
        this.dialogRef.close();
    }
}
